<div class="row">
    <div class="col-sm-12">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="borderStyle">Border Style</label></div>
            <ccl-simple-select formId="borderStyle"
                [listOfItems]="borderStyles"
                (valueChange)="sharedService.tabsConfig.borderStyle = $event.value"
                [value]="sharedService.tabsConfig.borderStyle"
                [bindLabel]="'label'"
                [bindValue]="'code'"
            >
            </ccl-simple-select>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="colorSelected">Selected Label Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="sharedService.tabsConfig.activeLabelColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
            >
                <input id="colorSelected"
                    cclFormInput
                    type="text"
                    [(ngModel)]="sharedService.tabsConfig.activeLabelColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': sharedService.tabsConfig.activeLabelColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="underlineSelected">Selected Underline Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="sharedService.tabsConfig.activeBorderColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'left'"
            >
                <input id="underlineSelected"
                    cclFormInput
                    type="text"
                    [(ngModel)]="sharedService.tabsConfig.activeBorderColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': sharedService.tabsConfig.activeBorderColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>

            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="colorUnselected">Unselected Label Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="sharedService.tabsConfig.inactiveLabelColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="colorUnselected"
                    cclFormInput
                    type="text"
                    [(ngModel)]="sharedService.tabsConfig.inactiveLabelColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': sharedService.tabsConfig.inactiveLabelColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div class="col-sm-6">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="underlineUnselected">Unselected Underline Color</label></div>
            <div
                class="input-group"
                [(colorPicker)]="sharedService.tabsConfig.inactiveBorderColor"
                [cpAlphaChannel]="'disabled'"
                [cpOutputFormat]="'hex'"
                [cpPosition]="'top'"
            >
                <input id="underlineUnselected"
                    cclFormInput
                    type="text"
                    [(ngModel)]="sharedService.tabsConfig.inactiveBorderColor"
                    class="c-form-group__input form-control"
                />

                <div class="input-group-append">
                    <span
                        class="c-color-picker input-group-text"
                        [ngStyle]="{ 'background-color': sharedService.tabsConfig.inactiveBorderColor }"
                        >&nbsp;</span
                    >
                </div>
            </div>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
    <div *ngIf="false" class="col-sm-12">
        <div class="c-form-group">
            <div class="c-form-group__label"><label for="cssStyle">CSS Styling</label></div>
            <textarea id="cssStyle" rows="10" class="form-control" [(ngModel)]="sharedService.tabsConfig.customCss"></textarea>
            <div class="c-form-group__hint">&nbsp;</div>
        </div>
    </div>
</div>
